import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ operations }) => {
    const empty = (operations.length === 0);
    if (empty) {
        return (
            <div className="rounded-0 alert alert-warning m-0">
                Nenhuma operação realizada até o momento.
            </div>
        ); 
    }
    return (
        <div className="table-responsive">
            <table className="table align-items-center table-flush">
                <TableHead />
                <TableBody operations={operations} />
            </table>
        </div>
    );
};

export default Table;


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/Table.js